export default [
  {
    title: "DMACC Unit Leads",
    contacts: [
      {
        title: "Data Management and Reporting Unit",
        name: "Kayla Denson, Kelly Dunn",
        email: "DataManagement_CP-CTNet@frontierscience.org"
      },
      {
        title: "Clinical Trials Auditing Unit",
        name: "Holly Shaw",
        email: "Audit_CP-CTNet@frontierscience.org"
      },
      {
        title: "Administrative and Coordinating Unit",
        name: "Kelly Miller",
        email: "Admin_CP-CTNet@frontierscience.org",
        phone: "(608) 262-8141"
      }
    ]
  },
  {
    title: "CP-CTNet DCP CONTACT",
    contacts: [
      {
        title: "Division of Cancer Prevention",
        name: "Don Johnsey, Program Officer",
        email: "johnseyd@mail.nih.gov",
        phone: "(240) 276-7029"
      }
    ]
  },
  {
    title: "DMACC Site Support Contacts",
    contacts: [
      {
        title: "Data Management, Data Entry in Rave, Protocol",
        email: "DataManagement_CP-CTNet@frontierscience.org"
      },
      {
        title: "Registration and Randomization",
        email: "Enrollment_CP-CTNet@frontierscience.org",
        phone: "(716) 834-0900 ext 7302"
      },
      {
        title: "Systems Access (Stars, Medidata Rave)",
        email: "UserSupport_CP-CTNet@frontierscience.org",
        phone: "(716) 834-0900 ext 7301"
      },
      {
        title: "Education and Training",
        email: "Training_CP-CTNet@frontierscience.org"
      },
      {
        title: "Auditing",
        email: "Audit_CP-CTNet@frontierscience.org"
      },
      {
        title: "Contact Management",
        email: "ContactAdmin_CP-CTNet@frontierscience.org"
      },
      {
        title: "Administrative",
        email: "Admin_CP-CTNet@frontierscience.org",
        phone: "(608) 262-8141"
      }
    ]
  },
];
